import { splitByDot } from "../../strings";
import { T, cond, identity, join, of } from "ramda";
import { isPathArray, isPathDot, isPathString } from "./predicates";
import { ensureArray } from "ramda-adjunct";


export const normalizePath = (path: any): string[] => {
  const result = cond([
    [isPathString, ensureArray] as any,
    [isPathDot, (splitByDot)],
    [isPathArray, identity],
    [T, () => []]
  ])(path) as string[];
  return result;
}

export const normalizePathDot = (path: any): string => {
  const result = cond([
    [isPathArray, join(".")] as any,
    [isPathDot, identity],
    [T, () => ""]
  ])(path);
  return result;
}
